import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, DataTypeB0102 } from 'store/ducks/Reportings/types';
import { columnsB0102 } from 'constants/reportColumns';

const B0102: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0102[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchRT0102(params);

      if (fetchedData && fetchedData.entities) {
        const allEntities = Object.values(fetchedData.entities).flat();
        const date = fetchedData.date;

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            lei_entity: dataItem.lei_entity,
            entity_name: dataItem.entity_name,
            country_name: dataItem.country_name?.slice(0, 2),
            entity_type: dataItem.entity_type,
            hierarchy_in_group: dataItem.hierarchy_in_group,
            parent_lei: dataItem.parent_lei,
            date_of_last_update: dataItem.date_of_last_update,
            integration_date: dataItem.integration_date,
            deletion_date: dataItem.deletion_date,
            currency: dataItem.currency,
            total_assets: dataItem.total_assets,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsB0102}
        dataSource={data}
        scroll={{ x: 'max-content' }}
        pagination={false}
      />
    </>
  );
};

export default B0102;
